import { queryClient } from "services";

import { QueryOptions } from "./types";

export function getQueryData<TQueryFnData>(
  queryOptions: QueryOptions<TQueryFnData | undefined>
) {
  return queryClient.getQueryData<TQueryFnData | undefined>(
    queryOptions.queryKey
  );
}
